import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer} from '@angular/platform-browser';

@Pipe({ name: 'safe' })
export class SafePipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) { }
  transform(url) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }
}





@Pipe({
  name: 'applicantSearch'
})
export class AplicantSearchPipe implements PipeTransform {

  transform(students: any[], searchTerm: string):any[] {

      if(!students || !searchTerm){
        return students;
      }

    return students.filter((x: any) => x.StudentNumber.toString().toLowerCase().startsWith(searchTerm.toLowerCase()) ||
      x.ProgrammeFullName.toString().toLowerCase().startsWith(searchTerm.toLowerCase()) ||
      x.ApplicatantFullName.toString().toLowerCase().startsWith(searchTerm.toLowerCase()));

  } 

}
